import React from 'react';

import styles from './Decorator.module.scss';

const { decorator: decoratorStyles, copy: copyStyles } = styles;

const Decorator = ({ copy = 'Decorator', color = 'green', customClass = '' }) => (
  <div className={`${decoratorStyles} ${customClass} ${styles[color]}`}>
    <div className={copyStyles}>{copy}</div>
  </div>
);

export default Decorator;
